import apiClient, { unwrap } from './client';

export const roomsApi = {
  getAll: async () => {
    const res = await apiClient.get('/rooms');
    return unwrap(res) ?? [];
  },

  create: async (room) => {
    const res = await apiClient.post('/rooms', room);
    return unwrap(res);
  },

  update: async (id, room) => {
    const res = await apiClient.put(`/rooms/${id}`, room);
    return unwrap(res);
  },

  remove: async (id) => {
    await apiClient.delete(`/rooms/${id}`);
  },
};
